import React from "react";
import {
  breakpointClasses,
  cls,
  cn,
  resolveElement,
  splitBreakpointProps,
} from "@/lib/utils";
import type { TypographyFirmProps } from "../types";

function TypographyFirm({
  as,
  asChild,
  className,
  ...props
}: TypographyFirmProps) {
  const Component = resolveElement(asChild, as, "span");
  const { bp, native } = splitBreakpointProps(props);
  const classes = breakpointClasses(bp);

  if (process.env.NODE_ENV !== "production" && as && asChild) {
    console.warn(
      `[Typography.Firm] 'asChild' renders the child element; 'as' is ignored.`,
    );
  }

  return (
    <Component
      className={cn(
        cls`
            font-bold
            text-primary
          `,
        className,
        classes,
      )}
      {...native}
    />
  );
}

export default TypographyFirm;
